<div class="login-background">
  <!--<floaters></floaters>-->
  <div class="login-container">
    <!-- ABCis Logo -->
    <div class="login-logo-container">
      <img class="login-logo" src="../../../assets/images/abcis-white.png" alt="ABCis Logo" />
      <ambient-circles></ambient-circles>
      <div class="login-divider"></div>
    </div>

    <!-- Form Container -->
    <div class="login-form" [@fadeInOut]="loginState">
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <!-- Login Label -->
        <span class="login-label">Welcome</span>

        <span class="login-subtext">Please log in below.</span>
        <!-- Username -->
        <mat-form-field color="primary" class="login-input-field" appearance="outline">
          <mat-label><mat-icon>person</mat-icon> Username</mat-label>
          <input formControlName="username" matInput placeholder="Username" />
        </mat-form-field>

        <!-- Password -->
        <mat-form-field color="primary" class="login-input-field" appearance="outline">
          <mat-label><mat-icon>lock</mat-icon> Password</mat-label>
          <input
            formControlName="password"
            type="password"
            autocomplete="on"
            matInput
            placeholder="Enter your password"
            [type]="hide ? 'password' : 'text'"
          />
          <button
            mat-icon-button
            tabIndex="-1"
            matSuffix
            type="button"
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <a class="forgot-link" (click)="setReset()"
          ><span class="forgot-message">Forgot password?</span></a
        >

        <!-- Submit button with accent color (green) -->
        <div class="margin-container">
          <form-button
            type="submit"
            [formButton]="loginButton"
            [isDisabled]="loginForm.invalid"
            color="accent"
          ></form-button>
        </div>
      </form>
    </div>

    <div class="reset-form" [@fadeInOut]="resetState">
      <form [formGroup]="resetForm" (ngSubmit)="resetPasswordSubmit()">
        <span class="login-label">Reset Password</span>

        <span class="login-subtext">Enter you email and we'll send you a link.</span>

        <mat-form-field color="primary" class="login-input-field" appearance="outline">
          <mat-label><mat-icon>alternate_email</mat-icon> Email</mat-label>
          <input formControlName="email" matInput placeholder="Email" />
        </mat-form-field>

        <div class="button-container margin-container">
          <button mat-flat-button type="button" class="back-button" (click)="setReset()">
            Back
          </button>

          <form-button
            type="submit"
            [formButton]="resetPasswordButton"
            [isDisabled]="resetForm.invalid"
            color="accent"
          ></form-button>
        </div>
      </form>
    </div>
  </div>
</div>
